
import { defineComponent } from "vue"
import { useStore } from "vuex"
import { rootState } from "../../services/store"

export default defineComponent({
  data() {
    return {
      store: useStore<rootState>()
    }
  },
  computed: {
    instance(props) {
      return props.store.getters.selectedInstance
    }
  },
  components: {}
})
